import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import omit from 'lodash/omit';
import { takeLatest, put } from 'redux-saga/effects';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
import {
  UpdateDocumentTaskPayload,
  updateDocumentTemplateTaskAction,
} from '../../actions';
import { updateDocumentTemplateTask } from '../../slices';
import { DocumentTemplate } from '../../types';
import { saveDocumentTemplate } from '../_save-template';

function* updateDocumentTemplateTaskSaga(
  action: PayloadAction<UpdateDocumentTaskPayload>,
) {
  const {
    payload: { docId, resourceSectionId, task: _task },
  } = action;

  const task = {
    ...omit(_task, ['resourceSectionId', 'resourceType']),
    taskId: _task.taskId,
  };

  try {
    yield put(
      updateDocumentTemplateTask({
        docId,
        resourceSectionId,
        task,
      }),
    );

    const template: DocumentTemplate =
      yield TemplatesAPI.getById<DocumentTemplate>(_task.taskId);

    yield TemplatesAPI.save<DocumentTemplate>({
      ...template,
      templateContent: {
        ...template.templateContent,
        ...task,
      },
    });

    yield saveDocumentTemplate(docId);
  } catch (error) {
    logger.error('an error updating the task in the document', { error });

    message.error('There was an error updating the task in the document');
  }
}
export const watchUpdateDocumentTemplateTaskSaga = function* () {
  yield takeLatest(
    updateDocumentTemplateTaskAction.type,
    updateDocumentTemplateTaskSaga,
  );
};
